import {
  initialState,
  Actions,
  State,
  GET_ALL_SUPPORT_TASKS,
  GET_ALL_SUPPORT_TASKS_SUCCESS,
  GET_ALL_SUPPORT_TASKS_ERROR,
  RESET_GET_ALL_SUPPORT_TASKS,
} from '../../types/support-tasks/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_SUPPORT_TASKS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_SUPPORT_TASKS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_SUPPORT_TASKS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_SUPPORT_TASKS:
      return initialState
    default:
      return state
  }
}

export default reducers
